/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sync_Last_Sync_Hours_AgoInputs */



/**
* | output |
* | --- |
* | "{count}h ago" |
*
* @param {Sync_Last_Sync_Hours_AgoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_last_sync_hours_ago = /** @type {((inputs: Sync_Last_Sync_Hours_AgoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Last_Sync_Hours_AgoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vor ${i?.count} Std.`)
	return /** @type {LocalizedString} */ (`${i?.count}h ago`)
});